import axios from 'axios';

// Helper function to handle fetch with auth and 401 handling
async function fetchWithAuth(url, options = {}) {
  const token = localStorage.getItem('token');
  const headers = { ...options.headers, Authorization: `Bearer ${token}` };
  const response = await fetch(url, { ...options, headers });
  if (response.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/auth'; // Redirect to login
    throw new Error('Session expired. Please log in again.');
  }
  return response;
}

const assessmentService = {
  async getCompanyId() {
    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'https://quantifaid-backend-757948789112.us-central1.run.app';
      const response = await fetchWithAuth(`${apiUrl}/auth/me/company-info`, {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error('Failed to fetch company ID');
      }
      const data = await response.json();
      return data.company_id;
    } catch (error) {
      console.error('Error in getCompanyId:', error);
      throw error;
    }
  },

  async runAssessment() {
    try {
      const companyId = await this.getCompanyId();
      const apiUrl = import.meta.env.VITE_API_URL || 'https://quantifaid-backend-757948789112.us-central1.run.app';
      const response = await fetchWithAuth(`${apiUrl}/assessments/run`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          company_id: companyId
        })
      });
      if (!response.ok) {
        throw new Error('Failed to run assessment');
      }
      return { status: 'queued' };
    } catch (error) {
      console.error('Error in runAssessment:', error);
      throw error;
    }
  },

  async getDashboardData() {
    try {
      const companyId = await this.getCompanyId();
      const apiUrl = import.meta.env.VITE_API_URL || 'https://quantifaid-backend-757948789112.us-central1.run.app';
      const response = await fetchWithAuth(`${apiUrl}/assessments/company/dashboard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          company_id: companyId
        })
      });
      if (!response.ok) {
        throw new Error('Failed to fetch dashboard data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error in getDashboardData:', error);
      throw error;
    }
  }
};

export default assessmentService; 